/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomSeparator from '../../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../../../SharedModules/Spinner/Spinner';
import { PLAN_TYPE_DATA, createForRadioData } from './utils/constant';
import CreateStubInvoiceHeader from './components/CreateStubInvoiceHeader';
import {
  getRebateProgramCode,
  setStubInvoiceFilterValue,
  setErrorMessages,
} from './store/action';

const CreateStubInvoice = () => {
  const dispatch = useDispatch();

  const [successMessages, setSuccessMessages] = useState([]);
  const loading = useSelector(
    (state) => state.sharedState.createStubInvoice.loading
  );

  const userDefault = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const stubInvoiceFilter = useSelector(
    (state) => state.sharedState.createStubInvoice.stubInvoiceFilter
  );

  const rebateDropdownData = useSelector(
    (state) => state.sharedState.createStubInvoice.rebateDropdownData
  );

  const errorMessages = useSelector(
    (state) => state.sharedState.createStubInvoice.errorMessages
  );

  const handleErrorMessages = useCallback(
    (messages) => {
      dispatch(setErrorMessages(messages));
    },
    [errorMessages]
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  useEffect(() => {
    dispatch(
      setStubInvoiceFilterValue('createFor', createForRadioData[0].value)
    );
  }, []);

  // handling refresh functionality
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/createStubInvoice') {
          if (errorMessages?.length > 0) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [errorMessages]);

 
  useEffect(() => {
    if (userDefault && (!stubInvoiceFilter || !stubInvoiceFilter.planType)) {
      if (userDefault.planTypeCd) {
        dispatch(setStubInvoiceFilterValue('planType', userDefault.planTypeCd));
      } else {
        dispatch(
          setStubInvoiceFilterValue('planType', PLAN_TYPE_DATA[0].value)
        );
      }
    }
  }, [userDefault]);

  useEffect(() => {
    if (stubInvoiceFilter && stubInvoiceFilter.planType) {
      dispatch(getRebateProgramCode(stubInvoiceFilter.planType));
    }
  }, [stubInvoiceFilter && stubInvoiceFilter.planType]);

  return (
    <div className="tabs-container tBillPanel custom-check">
      {loading && <Spinner load={loading} />}

      <CustomSeparator
        parent1="System"
        parent2="Technical Window"
        parent3="Online Fixes"
        parent4="Request Stub Invoice Creation"
      />

      {successMessages && (
        <DisplaySuccessMessages successMessages={successMessages} />
      )}
      {errorMessages && <DisplayErrorMessages errorMessages={errorMessages} />}

      <CreateStubInvoiceHeader
        searchFilter={stubInvoiceFilter}
        rebateData={rebateDropdownData}
        setErrorMessages={handleErrorMessages}
        setSuccessMessages={setSuccessMessages}
      />
    </div>
  );
};

export default CreateStubInvoice;
